export default class CountdownLatch {
  private onResolved: Promise<void>;

  private resolve: undefined | (() => void);

  constructor(private count: number) {
    this.onResolved = new Promise<void>((resolve) => {
      this.resolve = resolve;
    });
  }

  public countDown() {
    if (this.count > 0) {
      this.count -= 1;
      if (this.count <= 0) {
        this.resolve?.();
      }
    }
  }

  public onZero() {
    return this.onResolved;
  }
}
